// extracted by mini-css-extract-plugin
module.exports = {"heading":"YesNo_heading__2amWO","inputs":"YesNo_inputs__2P8zI"};